import React from "react";
import { RedrawIcon } from "../../assets/iconComponents/Redraw";
import { RequisitionModelSerializer } from "../../recoil/types";
import { GetTypographyContent } from "../shared/Typography/Typography";
import { TestResultsRedrawWrapper } from "./TestResults.styles";

export const TestResultsId = (
  requisition: RequisitionModelSerializer,
  label = "Test ID",
): React.ReactElement => {
  // CFC orders should never show the redraw badge.
  const showRedrawBadge = Boolean(
    requisition.redraw_parent && !requisition.is_cfc_included,
  );

  return (
    <>
      {GetTypographyContent({
        content: label,
        size: "medium",
        textColor: "greyMedium",
        isBold: true,
        isCaps: true,
      })}
      <TestResultsRedrawWrapper>
        {GetTypographyContent({
          content: requisition.req_identifier,
          size: "medium",
          textColor: "greyMedium",
        })}
        {showRedrawBadge && <RedrawIcon />}
      </TestResultsRedrawWrapper>
    </>
  );
};
